import { render } from "./Autenticacion.vue?vue&type=template&id=f96f091e&scoped=true"
import script from "./Autenticacion.vue?vue&type=script&lang=js"
export * from "./Autenticacion.vue?vue&type=script&lang=js"

import "./Autenticacion.vue?vue&type=style&index=0&id=f96f091e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96f091e"]])

export default __exports__